import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';
import { LiveInformation } from 'app/models/troubleshoot/live-information.model';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface IPerformanceFactsImages {
  actual: string;
  theo: string;
  loss: string;
  rate: string;
}

@Component({
    selector: 'app-performance-facts',
    templateUrl: './performance-facts.component.html',
    styleUrls: ['./performance-facts.component.scss'],
    standalone: false
})
export class PerformanceFactsComponent implements OnInit, OnChanges{
  @Input() budgetData?: any;
  @Input() facts: any;
  @Input() data: LiveInformation;
  @Input() unitOfMeasure: string;
  @Input() onMenuItemSelected: any;
  @Input() menuOptions: any;
  @Input() lessThanOneSpecialDisplay = false;
  @Input() isTurbine = false;
  @Input() showAlarmCount = false;
  @Output() itemChanged = new EventEmitter<any>();
  public colors = [];
  public image$: Observable<IPerformanceFactsImages>;
  public statusColor = null;
  public theme$: Observable<EThemeName>;
  public browserTimezone: string;
  public digits = "1.2-2";
  public validBudget = false;

  constructor(public themeService: ThemeService, public  tz: TimezoneService) {
  }

  ngOnInit() {
    this.browserTimezone = (this.tz.getBrowserTimezone());
    this.setStatusCode();
    this.getImages();
    this.colors = this.getColors();
    this.isValidBudget();
  }
  
  ngOnChanges() {
    this.setStatusCode();
    this.isValidBudget();
  }

  public isValidBudget(): void {
    this.validBudget = this.budgetData && Number.isFinite(this.budgetData.budget_budget) && Number.isFinite(this.budgetData.budget_actual);
  }

  public onItemSelected(event: any): void {
    this.itemChanged.emit(event);
  }

  private setStatusCode() {
    if (typeof this.facts !== 'undefined') {
      if (this.facts == null) {
        this.statusColor = null;
      } else {
        if (typeof this.facts.WTUR1_status !== 'undefined') {
          if (this.facts.WTUR1_status == null) {
            this.statusColor = 8;
          } else {
            this.statusColor = this.facts.WTUR1_status;
          }
        } else {
          this.statusColor = null;
        }
      }
    }
  }

  private getImages(): void {
    this. theme$ = this.themeService.getTheme();
    this.image$ = this.theme$.pipe(
      map((theme: EThemeName) => {
        const key = theme === EThemeName.DARK ? 'White' : 'DarkBlue';
        this.colors = this.getColors();
        return {
          actual: `assets/troubleshoot/Icon-ActualPower-${key}.svg`,
          theo: `assets/troubleshoot/Icon-TheoreticalPower-${key}.svg`,
          loss: `assets/troubleshoot/Icon-LostPower-${key}.svg`,
          rate: `assets/troubleshoot/Icon-InstalledPower-${key}.svg`
        };
      }
    ));
  }

  private getColors() {
    return [
      {
        backgroundColor: [
          this.themeService.getColor('--primary-background'),
          this.themeService.getColor('--charts-background'),
        ]
      },
    ];
  }
}
